module.exports = __webpack_public_path__ + "media/video2.64f267f2.mp4";